module.exports = __webpack_public_path__ + "img/simple_logo.ac39fa12.png";